import {processSolrPrograms} from '@nl/neu';
import {
	GET_FAV_VIDEOS, GET_FAV_VIDEOS_START, RESET_FAV_VIDEOS,
} from '../constants';

const getFavVideosAction = (programs, pageNumber, paging) => (
		{
			type: GET_FAV_VIDEOS,
			programs,
			pageNumber,
			paging,
		}
);

const resetFavVideosAction = () => (
	{
		type: RESET_FAV_VIDEOS,
	}
);

const getFavTeamProgramsPaging = (psPaging, pageSize) => {
	const paging = {};
	paging.pageSize = pageSize;
	paging.totalCount = psPaging.count;
	paging.totalPages = psPaging.totalPage;
	paging.hasNextPage = psPaging.totalPage > psPaging.pageNumber;
	return paging;
};

export const getFavVideos = (pageNumber = 1, callback) => (dispatch, getState) => {
	const {client: {data: {hasPs}},
		config: {data: {PROGRAM_PAGE_SIZE}}} = getState();
	if (hasPs) {
		dispatch({type: GET_FAV_VIDEOS_START, pageNumber});
		window.ps.getFavPrograms({
			ps: PROGRAM_PAGE_SIZE,
			pn: pageNumber,
		}, (data, paging) => {
			dispatch(getFavVideosAction(processSolrPrograms(data), pageNumber,
					getFavTeamProgramsPaging(paging, PROGRAM_PAGE_SIZE)));
			callback && callback(data, paging);
		}, {
			fl: 'sequence,pid,name,description,seoName,runtime,releaseDate,releaseDateLocal,beginDateTime,beginDateTimeLocal,purchaseTypeId,showTitle,seasonTitle,image,programCode,extUrl,episode,location,venue,eventId,tvRating,progType,masterImage,catId,catSEOName,cat',
		});
	}
};

export const resetFavVideos = () => (dispatch) => {
	dispatch(resetFavVideosAction());
};
